import {
    Box, Grid, Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

interface PropTypes {
    kValue: number;
    metrics: Models.IngestConfigApi.RelevanceTests.RelevanceMetrics;
}

const MetricBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: `1px solid ${theme.palette.divider}`,
}));

const MetricValue = styled(Typography)(() => ({
    fontWeight: 'bold',
    fontSize: '1.5rem',
}));

const MetricLabel = styled(Typography)(() => ({
    color: 'text.secondary',
    fontSize: '0.875rem',
}));

export const TestRunMetrics: React.FC<PropTypes> = ({
    kValue,
    metrics,
}) => {
    const precision = metrics.precisionAtK || 0;
    const recall = metrics.recallAtK || 0;
    const mrr = metrics.meanReciprocalRank || 0;
    const ndcg = metrics.normalizedDiscountedCumulativeGain || 0;

    return (
        <Box p={2} sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Grid container spacing={2}>
                <Grid item xs={3}>
                    <MetricBox>
                        <MetricValue>{precision.toFixed(2)}</MetricValue>
                        <MetricLabel>
                            Precision@
                            {kValue}
                        </MetricLabel>
                    </MetricBox>
                </Grid>
                <Grid item xs={3}>
                    <MetricBox>
                        <MetricValue>{recall.toFixed(2)}</MetricValue>
                        <MetricLabel>
                            Recall@
                            {kValue}
                        </MetricLabel>
                    </MetricBox>
                </Grid>
                <Grid item xs={3}>
                    <MetricBox>
                        <MetricValue>{mrr.toFixed(2)}</MetricValue>
                        <MetricLabel>MRR</MetricLabel>
                    </MetricBox>
                </Grid>
                <Grid item xs={3}>
                    <MetricBox>
                        <MetricValue>{ndcg.toFixed(2)}</MetricValue>
                        <MetricLabel>NDCG</MetricLabel>
                    </MetricBox>
                </Grid>
            </Grid>
        </Box>
    );
};
